<template>
    <input :id="question.label" v-model="value" type="checkbox" />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            value: false
        };
    },

    watch: {
        value: {
            handler(v) {
                this.$emit('input', v);
            },
            immediate: true
        }
    }
};
</script>
